import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import SettingsMenu from 'components/@home/@settings/SettingsMenu';
import Loading from 'components/common/Loading';
import deferRender from 'defer-render-hoc';
import { bool } from 'prop-types';
import React, { useMemo } from 'react';
import { Outlet } from 'react-router';
import connector from './connector';

const getStyles = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
    minHeight: 0,
  },
  loading: {
    flexGrow: 1,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  left: {
    display: 'none',
    width: 250,
    height: '100%',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  content: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
});

const SettingsScene = props => {
  const { isCompanyLoaded } = props;
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  if (!isCompanyLoaded) {
    return (
      <Box sx={styles.loading}>
        <Loading size={56} />
      </Box>
    );
  }

  return (
    <Box component="section" sx={styles.root}>
      <Box sx={styles.left}>
        <SettingsMenu />
      </Box>
      <Box sx={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};

SettingsScene.propTypes = {
  isCompanyLoaded: bool.isRequired,
};

export default deferRender(connector(SettingsScene));
